import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useQuery from '@/hooks/useQuery';
import { useContext, useMemo } from 'react';
import CompanyWorkspaceContext from '@/pages/company/WorkspaceRoute/CompanyWorkspaceContext';
import { getNestedCategory } from '@/domain/categories/helpers';
import { subtypeFilterSelector } from '@/domain/documents';

const useGridContext = ({ components, autocompleteApiInstance }) => {
  const params = useParams();
  const category = getNestedCategory(params);
  const query = useQuery();
  const subtypeFilter = useSelector(subtypeFilterSelector);
  const { companyType } = useContext(CompanyWorkspaceContext);
  const isConfidential = companyType === 'confidential';

  return useMemo(
    () => ({
      fetchParams: {
        isConfidential,
        category,
        ...query,
        // DA-19430: Inbox sub-type facet rides as a separate `subtags` key (parity with tile
        // search; NOT mixed into AG-Grid filterModel). Omitted when the "All" chip is active.
        ...(subtypeFilter ? { subtags: [subtypeFilter] } : {}),
      },
      components,
      autocompleteApiInstance,
    }),
    [isConfidential, query, category, subtypeFilter, components, autocompleteApiInstance],
  );
};

export default useGridContext;
